export default __webpack_public_path__ + "static/media/active_update_icon.9aca502e.svg";